module.exports = __webpack_public_path__ + "media/images/front/pc/article/thum02-3d54e1c6d72383b06f9575eeaee9a4fb.png";